module.exports = () => ({
  /** Re-usable text base styles for editors and end-users */
  ".base-editor-text": {
    "@apply ds-text-xl ds-leading-xl": 1,
    overflowWrap: "anywhere",
    "& > *": { "@apply ds-flow-root": 1 },

    /**
     * Overrides of current link base styles. Since both .button and .link depend on base styles (e.g. color), they are
     * exempted from this override. NOTE: these may be removed once base styles are updated.
     */
    "a:not(.link):not(.button)": {
      "@apply ds-text-primary-blue visited:ds-text-secondary-purple hover:ds-underline": 1,
    },

    /**
     * Overrides of current heading base styles. NOTE: these may be removed once base styles are updated.
     */
    h1: {
      "@apply ds-text-5xl ds-leading-2xl md:!ds-text-7xl md:!ds-leading-4xl": 1,
    },
    h2: {
      "@apply ds-text-4xl ds-leading-lg md:!ds-text-6xl md:!ds-leading-3xl": 1,
    },
    h3: {
      "@apply ds-text-2xl ds-leading-base md:!ds-text-4xl md:!ds-leading-xl": 1,
    },
    h4: {
      "@apply ds-text-lg ds-leading-sm md:!ds-text-2xl md:!ds-leading-base": 1,
    },

    ol: {
      "@apply ds-list-outside ds-list-decimal marker:ds-font-bold ds-pl-lg": 1,
    },
    ul: {
      "@apply ds-list-outside ds-list-disc marker:ds-text-primary-black ds-pl-lg": 1,
    },
    "ul[style*='list-style-type: check-mark;']": {
      li: {
        "@apply ds-list-none ds-relative": 1,
      },
      "li::before": {
        "@apply ds-inline-block ds-content-[''] ds-w-[18px] ds-h-[18px] ds-bg-primary-black ds-absolute ds-left-[-25px] ds-mt-[8px]": 1,
        "-webkit-mask-origin": "content-box",
        "-webkit-mask-repeat": "no-repeat",
        "-webkit-mask-position": "center",
        "-webkit-mask-image":
          "url('data:image/svg+xml;charset=utf-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0A%3C!--%20Generator%3A%20Adobe%20Illustrator%2024.1.2%2C%20SVG%20Export%20Plug-In%20.%20SVG%20Version%3A%206.00%20Build%200)%20%20--%3E%0A%3Csvg%20version%3D%221.1%22%20id%3D%22Ebene_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0A%09%20viewBox%3D%220%200%20283.5%20283.5%22%20style%3D%22enable-background%3Anew%200%200%20283.5%20283.5%3B%22%20xml%3Aspace%3D%22preserve%22%3E%0A%3Cpolygon%20points%3D%2299.2%2C246.8%204.2%2C151.8%2024.2%2C131.7%2099.2%2C206.7%20259.3%2C46.7%20279.3%2C66.7%20%22%2F%3E%0A%3C%2Fsvg%3E%0A')",
      },
    },

    "h1,h2,h3,h4,ol:not(:last-child),ul:not(:last-child),p:not(:last-child)": { "@apply ds-pb": 1 },

    em: { "@apply ds-italic": 1 },

    ".text-large": { "@apply ds-text-xl ds-leading-xl": 1 },
    ".text-small": { "@apply ds-text-base ds-leading-base": 1 },
    ".text-detail": { "@apply ds-text-sm ds-leading-sm": 1 },

    iframe: { "@apply ds-aspect-video ds-w-full ds-h-auto": 1 },
    img: {
      "@apply ds-w-full ds-h-auto sm:!ds-max-w-[100%] sm:!ds-w-auto": 1,
      "&.image-left": { "@apply ds-pb-xl sm:!ds-max-w-[50%] sm:!ds-float-left sm:!ds-pt-[10px] sm:!ds-pr-xl": 1 },
      "&.image-right": { "@apply ds-pb-xl sm:!ds-max-w-[50%] sm:!ds-float-right sm:!ds-pt-[10px] sm:!ds-pl-xl": 1 },
    },
  },

  /** Padding for editor view (TinyMCE) */
  ".base-editor-padding": {
    "@apply ds-pt ds-pb-2xl ds-px-xl md:!ds-pt-2xl md:!ds-pb-3xl md:!ds-px-3xl": 1,
  },

  ".content-group": {
    "@apply ds-flex ds-flex-col ds-gap-y-xl lg:!ds-gap-y-2xl ds-m-auto ds-max-w-[760px]": 1,
  },

  ".content-group-text": { "@apply ds-base-editor-text ds-max-w-[760px]": 1 },
  ".content-group-text-emphasized": {
    "@apply ds-px-xl ds-py-2xl md:!ds-p-3xl": 1,
  },

  ".content-group-media": {
    "@apply ds-flex ds-flex-col ds-gap-y-xl ds-w-full md:!ds-flex-row ds-gap-x-2xl ds-max-w-[760px]": 1,
    figure: {
      "@apply ds-flex ds-flex-col ds-grow ds-basis-0": 1,
      "&:only-child figcaption": { "@apply md:!ds-py-xl": 1 },
      img: { [`@apply ds-w-full ds-object-cover ds-grow`]: 1 },
      figcaption: {
        "@apply ds-flex ds-px-lg ds-py-sm": 1,
        "&::before": {
          "@apply ds-content-[''] ds-w ds-my-[2px] ds-border-l-2": 1,
        },
      },
    },
  },

  /** Used in TinyMCE editor for content-group-text */
  ".content-group-text-editor": {
    "@apply ds-base-editor-text": 1,
    "@apply ds-base-editor-padding": 1,
    "@apply ds-w-full ds-max-w-[760px]": 1,
  },
});
